export const allColors: string[][] = [
  [
    '#000000', '#434343', '#666666', '#999999',
    '#b7b7b7', '#cccccc', '#d9d9d9', '#efefef',
    '#f3f3f3', '#ffffff'
  ],
  [
    '#980000', '#ff0000', '#ff9900', '#ffff00',
    '#00ff00', '#00ffff', '#4a86e8', '#0000ff',
    '#9900ff', '#ff00ff'
  ],
  [
    '#e6b8af', '#f4cccc', '#fce5cd', '#fff2cc',
    '#d9ead3', '#d0e0e3', '#c9daff', '#cfe2f3',
    '#d9d2e9', '#ead1d9'
  ],
  [
    '#dd7f6d', '#ea9999', '#f9cb9c', '#ffe599',
    '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8',
    '#b4a7d6', '#d5a6bd'
  ],
  [
    '#cc4125', '#e06666', '#f6b22b', '#ffda66',
    '#93c47d', '#76a5af', '#6d9dc5', '#6fa8dc',
    '#8e7cc3', '#c23b8e'
  ],
  [
    '#a62800', '#cc0000', '#e69138', '#f1c700',
    '#6aa84f', '#458091', '#3c78d8', '#3d85c6',
    '#674ea7', '#a64679'
  ],
  [
    '#851f0c', '#990000', '#b43f02', '#bf9000',
    '#38761d', '#134f5c', '#1155cc', '#0b5394',
    '#352c75', '#741b47'
  ],
  [
    '#5b0f00', '#660000', '#783f04', '#7f6000',
    '#274e13', '#0c344d', '#1c4587', '#073763',
    '#20124d', '#4c1120'
  ],
];
